import Reflux from "reflux";
import * as Immutable from "immutable";
import URI from "urijs";
import UserOverview from "logic/users/UserOverview";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { singletonStore, singletonActions } from "logic/singleton";
import { qualifyUrl } from "util/URLUtils";
import PaginationURL from "util/PaginationURL";
import User from "logic/users/User";
const usersUrl = ({ url = "", query = {} }) => {
  const uri = new URI(url);
  uri.query(query);
  return qualifyUrl(uri.resource());
};
export const UsersActions = singletonActions(
  "core.Users",
  () => Reflux.createActions({
    create: { asyncResult: true },
    load: { asyncResult: true },
    loadByUsername: { asyncResult: true },
    update: { asyncResult: true },
    delete: { asyncResult: true },
    changePassword: { asyncResult: true },
    createToken: { asyncResult: true },
    loadTokens: { asyncResult: true },
    deleteToken: { asyncResult: true },
    loadUsersPaginated: { asyncResult: true },
    loadUsers: { asyncResult: true },
    setStatus: { asyncResult: true }
  })
);
export const UsersStore = singletonStore(
  "core.Users",
  () => Reflux.createStore({
    listenables: [UsersActions],
    create(user) {
      const url = qualifyUrl(ApiRoutes.UsersApiController.create().url);
      const promise = fetch("POST", url, user);
      UsersActions.create.promise(promise);
      return promise;
    },
    load(id) {
      const url = qualifyUrl(ApiRoutes.UsersApiController.load(encodeURIComponent(id)).url);
      const promise = fetch("GET", url).then(User.fromJSON);
      UsersActions.load.promise(promise);
      return promise;
    },
    loadByUsername(userId) {
      const url = qualifyUrl(ApiRoutes.UsersApiController.loadByUsername(encodeURIComponent(userId)).url);
      const promise = fetch("GET", url).then(User.fromJSON);
      UsersActions.loadByUsername.promise(promise);
      return promise;
    },
    update(userId, user) {
      const url = qualifyUrl(ApiRoutes.UsersApiController.update(encodeURIComponent(userId)).url);
      const promise = fetch("PUT", url, user);
      UsersActions.update.promise(promise);
      return promise;
    },
    delete(userId) {
      const url = qualifyUrl(ApiRoutes.UsersApiController.delete(encodeURIComponent(userId)).url);
      const promise = fetch("DELETE", url);
      UsersActions.delete.promise(promise);
      return promise;
    },
    changePassword(userId, request) {
      const url = qualifyUrl(ApiRoutes.UsersApiController.changePassword(encodeURIComponent(userId)).url);
      const promise = fetch("PUT", url, request);
      UsersActions.changePassword.promise(promise);
      return promise;
    },
    createToken(userId, tokenName, tokenTtl) {
      const url = qualifyUrl(
        ApiRoutes.UsersApiController.create_token(encodeURIComponent(userId), encodeURIComponent(tokenName)).url
      );
      const promise = fetch("POST", url, { token_ttl: tokenTtl });
      UsersActions.createToken.promise(promise);
      return promise;
    },
    loadTokens(userId) {
      const url = qualifyUrl(ApiRoutes.UsersApiController.list_tokens(encodeURIComponent(userId)).url);
      const promise = fetch("GET", url).then((response) => response.tokens);
      UsersActions.loadTokens.promise(promise);
      return promise;
    },
    deleteToken(userId, tokenId) {
      const url = qualifyUrl(
        ApiRoutes.UsersApiController.delete_token(encodeURIComponent(userId), encodeURIComponent(tokenId)).url
      );
      const promise = fetch("DELETE", url);
      UsersActions.deleteToken.promise(promise);
      return promise;
    },
    loadUsers(query = {}) {
      const url = usersUrl({ url: ApiRoutes.UsersApiController.list().url, query });
      const promise = fetch("GET", url).then(
        ({ users }) => Immutable.List(users.map((user) => UserOverview.fromJSON(user)))
      );
      UsersActions.loadUsers.promise(promise);
      return promise;
    },
    loadUsersPaginated({ page, perPage, query }) {
      const url = PaginationURL(ApiRoutes.UsersApiController.paginated().url, page, perPage, query);
      const promise = fetch("GET", qualifyUrl(url)).then((response) => {
        var _a;
        return {
          adminUser: ((_a = response.context) == null ? void 0 : _a.admin_user) ? UserOverview.fromJSON(response.context.admin_user) : void 0,
          list: Immutable.List(response.users.map((user) => UserOverview.fromJSON(user))),
          pagination: {
            page: response.page,
            perPage: response.per_page,
            query: response.query,
            count: response.count,
            total: response.total
          }
        };
      });
      UsersActions.loadUsersPaginated.promise(promise);
      return promise;
    },
    setStatus(userId, accountStatus) {
      const url = qualifyUrl(ApiRoutes.UsersApiController.setStatus(userId, accountStatus).url);
      const promise = fetch("PUT", url);
      UsersActions.setStatus.promise(promise);
      return promise;
    }
  })
);
